$(document).ready(function() {
  var toggleBurger, menu;
  var fixedMenu = $('.o-header__menuContainer');
  var fixedMenuMobile = $('.o-header__menuMobile');
  var hauteurMenuMobile = fixedMenuMobile.height();
  var sousMenu = $('.o-header__content');

  //menu déroulant du menu mobile
  $('.o-header__menuMobile').each(function() {
    var block = $(this);
    toggleBurger = block.find('.o-header__menuMobile__button');
    menu = $('.o-header__content');

    toggleBurger.on('click', function() {
      $(this).toggleClass('open');
      menu.slideToggle(400);
    });

    $(window).on('load resize', function() {
      if ($(window).width() <= 1023) {
        menu.hide();
      } else {
        menu.show();
      }
    });
  });

  //sticky menu au scroll
  $(window).on('load scroll', function() {
    var offset = $(this).scrollTop();
    if ((offset >= 1) & ($(window).width() >= 1023)) {
      fixedMenu.addClass('sticky');
    } else if ((offset >= 0) & ($(window).width() <= 1023)) {
      fixedMenuMobile.addClass('sticky');
      sousMenu.css({ top: hauteurMenuMobile + offset, zIndex: '1' });
    } else {
      fixedMenu.removeClass('sticky');
      fixedMenuMobile.removeClass('sticky');
      sousMenu.css({ top: '63px' });
    }
  });

  $(window).on('load scroll', function() {
    var offset = $(this).scrollTop();
    if ((offset >= 308) & ($(window).width() >= 1023)) {
      fixedMenu.addClass('background');
    } else {
      fixedMenu.removeClass('background');
    }
  });

  // faire disparaitre les elements progressivement au scroll

  var fadeStart=0,
  fadeUntil= fixedMenu.height() + 100,
  fading = $('.fading');

  $(window).on('scroll', function(){
    var offset = $(document).scrollTop(),
        opacity= 0;

    if( offset<=fadeStart ){
        opacity=1;

    } else if( offset<=fadeUntil ){
        opacity= 1-offset/fadeUntil;
    }
    fading.css('opacity',opacity);
  });

  $('.list').each(function() {
    var block = $(this),
        slideToShow = block.find('.sub-menu'),
        linkTitle = block.find('.o-linkTitle');

    block.on('click', function() {
        if ($(window).width() <= 1023) {
          linkTitle.toggleClass('active');
          slideToShow.toggleClass('open');
          slideToShow.slideToggle(400);
        }
    });
  });
});
